<h2>Update Email</h2>
<div class="field w-full">
    <span>Current Email: {{emailCurrent}}</span>
</div>
<br>
<div class="field w-full">
    <p-floatlabel variant="on">
        <input class="w-full mt-2" #email1="ngModel" id="email1" required [(ngModel)]="emailNew" type="text" pInputText style="padding:1rem"  />
        <label for="email1" class="w-full block text-900 font-medium text-xl mb-2">New Email</label>
    </p-floatlabel>
</div>

<div>
    <button [disabled]="!emailNew || email1.invalid || confirmationCodeCheck"  pButton pRipple label="Step 1: Send Confirmation Code" class="w-full mt-5  text-xl" (click)="sendConfirmationCode()" ></button>
</div>

<div *ngIf="confirmationCodeCheck" class="field w-full">
    <small style="color: green" class="mb-5">Confirmation Code Sent to New Email.</small>
</div>

<br>

<div class="field w-full" style="padding-top: 5%;">
    <p-floatlabel variant="on">
        <input [disabled]="!confirmationCodeCheck" class="w-full mt-2" #code1="ngModel" id="code1" required [(ngModel)]="confirmationCode" type="text" pInputText style="padding:1rem"  />
        <label for="code1" class="w-full block text-900 font-medium text-xl mb-2">Confirmation Code</label>
    </p-floatlabel>
</div>



<div>
    <button [disabled]="!emailNew || email1.invalid || !confirmationCodeCheck || code1.invalid"  pButton pRipple label="Step 2: Change Email" class="w-full mt-5  text-xl" (click)="updateEmail()" ></button>
</div>
<div *ngIf="emailChangeCheck" class="field w-full">
    <small style="color: green" class="mb-5">Email Successfully Updated.</small>
</div>

<h2>Password Change</h2>
<div class="field w-full">
    <p-floatlabel variant="on">
        <p-password [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" #password0="ngModel" id="passwordOld" required [(ngModel)]="passwordOld" [feedback]="false" [toggleMask]="true" inputStyleClass="w-full mt-2 p-3 md:w-30rem"></p-password>
        <label for="passwordOld" class="w-full block text-900 font-medium text-xl mb-2">Current Password</label>
    </p-floatlabel>
</div>
<br>
<div class="field w-full">
    <p-floatlabel variant="on">
        <p-password [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" #password1="ngModel" [ngClass]="{'ng-invalid ng-dirty' : password2.value !== password1.value && (password1.touched) && (password2.touched)}" id="password1" required [feedback]="true" [(ngModel)]="password" [toggleMask]="true" inputStyleClass="w-full mt-2 p-3 md:w-30rem">
            <ng-template pTemplate="header">
                <h6>Pick a new password</h6>
            </ng-template>
            <ng-template pTemplate="footer">
                <p-divider></p-divider>
                    <p class="mt-2">Suggestions</p>
                        <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                            <li>At least one lowercase letter</li>
                            <li>At least one uppercase letter</li>
                            <li>At least one number</li>
                            <li><strong>Minimum 8 characters required</strong></li>
                        </ul>
            </ng-template>
        </p-password>
        <label for="password1" class="w-full block text-900 font-medium text-xl mb-2">New Password</label>
    </p-floatlabel>
</div>
<div [style.visibility]="((password2.value !== password1.value || password1.invalid) && (password1.dirty || password1.touched))?'visible':'hidden'" class="field w-full">
                        <small style="color: red" class="mb-5"><i class="pi pi-exclamation-triangle"></i> {{(!password || password.length < 8)?'New Password is too short. Please enter your password.':"Passwords don't match."}}</small>
</div>
<br>
<div class="field w-full">
    <p-floatlabel variant="on">
        <p-password [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" #password2="ngModel" [ngClass]="{'ng-invalid ng-dirty' : password2.value !== password1.value && (password1.touched) && (password2.touched)}" id="password2" required [(ngModel)]="newPassword" [feedback]="false" [toggleMask]="true" inputStyleClass="w-full mt-2 p-3 md:w-30rem"></p-password>
        <label for="password2" class="w-full block text-900 font-medium text-xl mb-2">Confirm Password</label>
    </p-floatlabel>
</div>
<div [style.visibility]="((password2.value !== password1.value || password2.invalid) && (password2.dirty || password2.touched))?'visible':'hidden'" class="field w-full">
    <small style="color: red" class="mb-5"><i class="pi pi-exclamation-triangle"></i> {{(password1.invalid)?'Confirm Password is required. Please enter your password a second time.':"Passwords don't match."}}</small>
</div>
<div>
    <button [disabled]="!passwordOld || !password || !newPassword || password2.value !== password1.value || password2.invalid || password1.invalid || password0.invalid"  pButton pRipple label="Change Password" class="w-full mt-5  text-xl" (click)="updatePassword()"></button>
</div>
<div *ngIf="changeCheck" class="field w-full">
    <small style="color: green" class="mb-5">Password successfully changed.</small>
</div>